import "./App.css";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrivateRoutes from "./routing/PrivateRoutes";
import Alert from "./components/Alert/Alert";
import AuthRoutes from "./routing/AuthRoutes";
import { sync_data_thunk } from "./redux/auth/authThunk";
// import Alert from './components/Loader/Alert';
function App() {
  // Get total space used (in bytes)
  const getLocalStorageSize = () => {
    let total = 0;
    for (let key in localStorage) {
      if (localStorage.hasOwnProperty(key)) {
        total += (localStorage[key].length + key.length) * 2;
      }
    }
    return total;
  };

  // Get remaining space (varies by browser)
  const getRemainingSpace = () => {
    const testKey = "test";
    let max = "";
    try {
      while (true) {
        max += "a".repeat(1024 * 1024); // Add 1MB
        localStorage.setItem(testKey, max);
      }
    } catch (e) {
      localStorage.removeItem(testKey);
      return max.length;
    }
  };

  console.log(`Used: ${getLocalStorageSize() / 1024 / 1024} MB`);
  console.log(`Available: ${getRemainingSpace() / 1024 / 1024} MB`);
  let tokenState = localStorage.getItem("todoToken");
  let bool = false;
  if (tokenState) {
    bool = true;
  }
  const [currentUser, setCurrentUser] = useState(bool);

  const auth = useSelector((state) => state.auth?.isLogin);
  const dispatch = useDispatch();
  useEffect(() => {
    if (typeof localStorage !== "undefined") {
      const token = localStorage.getItem("todoToken");
      const isLoggedIn = token;
      setCurrentUser(isLoggedIn);
    }
  }, [dispatch, auth]);

  const handleSync = async () => {
    const token = localStorage.getItem("todoToken");
    dispatch(sync_data_thunk({ token }));
  };
  useEffect(() => {
    // Run immediately on mount
    console.log("syncing");

    // Set up hourly interval (3600000 ms = 1 hour)
    if (currentUser) {
      handleSync();
      const intervalId = setInterval(handleSync, 3600000);
      return () => clearInterval(intervalId);
    }

    // Cleanup on unmount
  }, []);

  return (
    <>
      <Alert />
      <Router>
        {/* only for react to logout  */}
        {/* <RedirectHash /> */}
        <Routes>
          {!currentUser ? (
            <>
              <Route path="/*" element={<AuthRoutes />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          ) : (
            <>
              <Route path="/*" element={<PrivateRoutes />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </Router>
    </>
  );
}

export default App;
